export default __webpack_public_path__ + "static/media/featSport.c9523001.jpg";